
import { mapGetters } from 'vuex'

import { removeEmptyValuesInObject } from '@core/helpers'
import { logger } from '@recommendation/helpers'

import Layout, { fetch as fetchLayout } from '../../components/Layout'
import { createCanonicalPageQueryString } from '../helpers'

import translations from './SellerLanding.translations'
import TopLanding, { fetch as fetchTopLanding } from './components/TopLanding'

export default {
  components: {
    Layout,
    TopLanding,
  },
  layout: 'empty',

  async asyncData({ route, redirect }) {
    // Previously, we rendered the first page with ?page=1 query string in the Pagination component.
    // Since we removed it, let's redirect the page to keep the SEO we built on it and avoid duplicated content.
    if (route.query.page && parseInt(route.query.page, 10) === 1) {
      return redirect(301, {
        name: route.name,
        params: route.params,
        query: removeEmptyValuesInObject({ ...route.query, page: undefined }),
      })
    }

    return {}
  },

  async fetch(args) {
    // The landing ID is necessary in the next calls. So we need to do that first.
    // Once the URL migration over, we will be able to // everything by reading the URL
    try {
      await Promise.all([fetchLayout(args), fetchTopLanding(args)])
    } catch (error) {
      logger.info(error, {
        component: { name: 'SellerLanding', props: null },
        routeName: args.route.name,
      })

      if (error.status_code === 429) {
        // Make sure to let 429 errors through, in order to improve the caching
        // strategy on Cloudflare side.
        args.error({ statusCode: 429, message: 'Too Many Requests' })
      }

      args.error({ statusCode: 404, message: 'Page Not Found' })
    }
  },

  head() {
    const { path, query } = this.$route

    const page = createCanonicalPageQueryString(query)

    return {
      title: this.seoTitleWithPage,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t(translations.landingSellerMetaDescriptionNew, {
            merchantName: this.company,
          }),
        },
      ],
      link: [
        {
          href: `${this.baseURL}${path}${page}`,
          rel: 'canonical',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({ company: 'landing/company', baseURL: 'config/baseURL' }),

    seoTitleWithPage() {
      const searchCurrentPage = this.$route.query?.page

      if (parseInt(searchCurrentPage, 10) > 1) {
        return this.$t(translations.landingSellerMetaTitleWithPage, {
          sellerName: this.company,
          pageNumber: searchCurrentPage,
        })
      }

      return this.$t(translations.landingSellerMetaTitleNew, {
        // FIXME: property name should be seller instead of merchant
        merchantName: this.company,
      })
    },
  },
}
